import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IWidgetsReqAndRes } from "../../Orchestrator/Types/Interface/IWidgetsReqAndRes";

export async function getAllWidgets(): Promise<IApiResponse<IWidgetsReqAndRes>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.manageWidgetAPI;
    // Widget-visibility config for the search screen — background data, never
    // raise the blocking loader. The POST (user saving preferences) keeps it.
    return await apiRequest<IWidgetsReqAndRes>(endpoint, 'GET', {}, "none", undefined, undefined, false);
}

export async function setAllWidgets(payload: any): Promise<IApiResponse<IWidgetsReqAndRes>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.manageWidgetAPI;

    return await apiRequest<IWidgetsReqAndRes>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}
